export const SET_SELECTED_DASHBOARD_ROLE = 'SET_SELECTED_DASHBOARD_ROLE';

export const RESET_SELECTED_DASHBOARD_ROLE = 'RESET_SELECTED_DASHBOARD_ROLE';